import ReactDOM from 'react-dom'
import videojs from 'video.js'
import React from 'react'
import PlayIcon from '../../../../assets/codicons/play-80'

const vjsComponent = videojs.getComponent('Component')

class PlayButton extends vjsComponent {
  constructor(player, options) {
    super(player, options)

    player.ready(() => {
      this.mountElement()
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })
  }

  mountElement() {
    ReactDOM.render(this.createPlayButton(), this.el())
  }

  createPlayButton() {
    return (
      <React.Fragment>
        <PlayIcon />
      </React.Fragment>
    )
  }
}

vjsComponent.registerComponent('PlayButton', PlayButton)

export default PlayButton
